//
//
//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ActivityEnum, AlertLevelEnum } from '@shared/Enums'
import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'
import { dispatchError, OtStoreState } from '@react/redux/store'
import { ETH_ADDR_ZERO, EthAddr } from '@shared/SchemaTypes'
import { alertActions } from '@react/redux/alertSlice'
import { wsServerActionBalanceRefresh } from '@shared/WsServerActions'

import { logOT } from '@shared/loggingShared'

export const refreshBalancesThunk =
  (accountAddr: EthAddr, chainConfigurationName: string): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.LOGIN
    try {
      const { webSocket } = getState().chainState

      webSocket?.send(
        wsServerActionBalanceRefresh(ActivityEnum.POOL_LENDER_BALANCES, accountAddr, chainConfigurationName)
      )
      logOT.info('refreshBalancesThunk 6')
    } catch (e: any) {
      dispatch(
        alertActions.addAlert({
          title: 'Cound Login',
          description: 'Cound Login',
          createdAt: Date.now() / 1000,
          dueDateTime: Date.now() / 1000,
          txHash: '',
          sourceObjectAddr: ETH_ADDR_ZERO,
          alertLevel: AlertLevelEnum.ERROR,
        })
      )
      await dispatchError(dispatch, e, activity, 1057)
    }
  }
